<template>
  <div id="app">
    <div v-if="tosAcceptance === 'accepted'">
      <router-view/>
    </div>
    <div v-else>
      <b-container>
        <b-row>
          <b-col>
            <big-panel title="Optimum Load Shape Signal Viewer">
              <div class="sub-title">
                RCA Products and Services Warranties & Disclaimers
              </div>
              <div class="mt-3 mb-3">
                <b-form-checkbox
                  v-model="tosAcceptance"
                  value="accepted"
                  unchecked-value="not_accepted"
                  @change="setTOSAccepted()"
                >
                  I accept the Warranties and Disclaimers
                </b-form-checkbox>
              </div>
              <div>
                <b-button v-b-toggle.collapse-1 class="m-1">View Warranties and Disclaimers</b-button>
                <b-collapse id="collapse-1" class="mt-4 mb-4">
                  <ul>
                  <li>
                    RCA does not guarantee that its products, OLS signals, services, including its online portal or APIs, etc conform to any regulations, environmental, energy, or otherwise, in the United States or any other country, and that any liability or damage arising from the transgression of those regulations are wholly subsumed by the user or buyer.
                  </li><li>
                    RCA assumes no liability for any damages (revenue, property or personal damages, loss of life, or otherwise) caused by its products, OLS signals, services, including its online portal or APIs, etc for any reason whatsoever, including but not limited to environmental damage, such as fire, or power or network outage.
                  </li><li>
                    User or buyer agrees to use RCA’s products, OLS signals, services, including its online portal or APIs, etc responsibly and not in violation of any laws or regulations, and that any such violation thereof, either intentional or otherwise, is the sole responsibility of user or buyer.
                  </li><li>
                    RCA does not guarantee that users or buyers, by use of its products, OLS signals, services, including its online portal or APIs, etc, will accrue a profit or savings.
                  </li><li>
                    User or buyer agrees not to export or use RCA products, OLS signals, services, including its online portal or APIs, etc, outside the United States, and that purchase or license thereof is restricted for use within the United States.
                  </li><li>
                    User or buyer agrees and RCA makes no guarantee any price accuracy of its products, OLS signals, services, including its online portal or APIs, etc, and any data on pricing is the sole responsibility of 3rd party providers of that pricing data.
                  </li><li>
                    RCA products, OLS signals, services, including its online portal or APIs, etc are to be used as intended, are for internal purposes only of user or buyer, and are not to be used for other than power management applications.
                  </li><li>
                    RCA does not guarantee that any endpoint’s price reporting will be available or that it not be discontinued and has no control or authority as to the availability or consistency of available pricing data.
                  </li><li>
                    User or buyer agrees to be responsible for maintaining and securing the privacy of information of private entities or corporate entities and holds RCA harmless for any breach of privacy.
                  </li><li>
                    RCA is not responsible for theft or hacker attacks, ransom or malware attacks, loss of revenues, property damages, loss of life, etc, and user or buyer shall hold RCA harmless if damages (revenue, property or personal damages, loss of life, or otherwise) are suffered as a result of such attacks, and furthermore, user or buyer agrees to secure its applications, software, data, etc from such attacks.
                  </li><li>
                    User or buyer agrees not to resell any of RCAs products, services, including its online portal or APIs, etc.
                  </li><li>
                    RCA is not responsible and shall be held harmless for any violations of antitrust, patent, trademark, trade secret, copyright, or other intellectual property violation worldwide by purchase or use of its products, OLS signals, services, including its online portal or APIs, etc, and that buyer shall subsume the costs and damages of such violations resulting in court judgement, settlement, or governmental fines thereof.
                  </li><li>
                    RCA’s products, OLS signals, services, including its online portal or APIs are not free for commercial use and require license or purchase.
                  </li><li>
                    All sales are final. No returns.
                  </li>
                  </ul>
                </b-collapse>
              </div>
            </big-panel>
          </b-col>
        </b-row>
      </b-container>

    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import BigPanel from '@/components/BigPanel'
export default {
  components: {
    BigPanel
  },
  data () {
    return {
      tosAcceptance: null
    }
  },
  created () {
    const self = this
    axios.get('version.json').then(function (r) {
      const version = r.data.major + '.' + r.data.minor + '.' + r.data.build
      self.setVersion(version)
      console.log('set this.version = ' + version)
    }, function (err) {
      console.log('error getting version: ' + JSON.stringify(err))
    })
    this.tosAcceptance = window.localStorage.getItem('tosAcceptance')
    console.log('tosAcceptance: ' + this.tosAcceptance)
  },
  computed: {
    ...mapGetters(['version'])
  },
  methods: {
    ...mapActions(['setVersion']),
    setTOSAccepted () {
      window.localStorage.setItem('tosAcceptance', 'accepted')
    }
  }
}
</script>
<style lang="scss">
@import 'assets/custom.scss';
@import '~bootstrap/scss/bootstrap.scss';
@import '~bootstrap-vue/src/index.scss';

#nav {
  text-align: center;
  margin: 8px;
  font-weight: 700;
  font-size: 110%;
}

.footer {
  margin-left:  10px;
  margin-bottom:  10px;
}
</style>
